import React from 'react';
import { Badge } from 'chic-ui';
import { Row } from 'react-bootstrap';

const Rounded = () => {
  return (
    <div>
      <h4 className="mt-5">Rounded Badges</h4>
      <p>
       Get pill shaped badges using the <i>rounded</i> prop.
      </p>
      <div className="btn-group btns mt-3">
        <Badge className="single-btn" rounded>
            Default
        </Badge>
        <Badge className="single-btn" type="secondary" rounded>
          Secondary
        </Badge>
        <Badge className="single-btn" type="danger" rounded>
          Danger
        </Badge>
      </div>
      <div className="btn-group btns mt-3">
        <Badge className="single-btn" type="success" rounded>
          Success
        </Badge>
        <Badge className="single-btn" type="warning" rounded>
          Warning
        </Badge>
        <Badge className="single-btn" type="light" rounded>
          Light
        </Badge>
      </div>

      <Row className="mt-3" fluid>
        <code>
          {'import { Badge } from "chic-ui";'}
          <br />
          {'<Badge rounded>Default</Badge>'}
          <br />
          {'<Badge type="secondary" rounded>Secondary</Badge>'}
          <br />
          {'<Badge type="danger" rounded>Danger</Badge>'}
          <br />
          {'<Badge type="success" rounded>Success</Badge>'}
          <br />
          {'<Badge type="warning" rounded>Warning</Badge>'}
          <br />
          {'<Badge type="light" rounded>Light</Badge>'}
        </code>
      </Row>
    </div>
  );
};

export default Rounded;
